import styled from "styled-components";

import { variant } from "styled-system";

const smallSize = {
  fontSize: "12px",
  padding: "4px 8px",
};

const bigSize = {
  fontSize: "14px",
  padding: "8px 16px",
};

export const Button = styled("button")(
  {
    border: "1px solid",
    borderRadius: "4px",
    fontWeight: "bold",
    lineHeight: "1.71",
    letterSpacing: "0.2px",
    transition: "background-color 0.3s ease-in-out",

    "&:disabled": {
      backgroundColor: "#f4f5f8",
      borderColor: "#e6e8f0",
      color: "#ccd2e1",
      cursor: "not-allowed",
    },
    "&:disabled:hover": {
      backgroundColor: "#f4f5f8",
      borderColor: "#e6e8f0",
      color: "#ccd2e1",
      cursor: "not-allowed",
    },
  },

  variant({
    variants: {
      basic: {
        borderColor: props => props.colors.grey.colorGrey30,
        backgroundColor: props => props.colors.grey.colorGrey10,
        color: props => props.colors.grey.colorGrey60,
        padding: "4px 8px",
        ...smallSize,

        "&:hover": {
          backgroundColor: props => props.colors.grey.colorGrey20,
          borderColor: props => props.colors.grey.colorGrey40,
        },
      },
      basicBig: {
        borderColor: props => props.colors.grey.colorGrey30,
        backgroundColor: props => props.colors.grey.colorGrey10,
        color: props => props.colors.grey.colorGrey60,
        padding: "4px 8px",
        ...bigSize,

        "&:hover": {
          backgroundColor: props => props.colors.grey.colorGrey20,
          borderColor: props => props.colors.grey.colorGrey40,
        },
      },
      primary: {
        borderColor: props => props.colors.green.colorGreen45,
        backgroundColor: props => props.colors.green.colorGreen40,
        color: props => props.colors.white.colorWhite,
        ...smallSize,

        "&:hover": {
          backgroundColor: props => props.colors.grey.colorGreen46,
          borderColor: props => props.colors.grey.colorGreen48,
        },
      },
      primaryBig: {
        borderColor: props => props.colors.green.colorGreen45,
        backgroundColor: props => props.colors.green.colorGreen40,
        color: props => props.colors.white.colorWhite,
        ...bigSize,

        "&:hover": {
          backgroundColor: props => props.colors.green.colorGreen46,
          borderColor: props => props.colors.green.colorGreen48,
        },
      },
      brand: {
        borderColor: props => props.colors.purple.colorPurple20,
        backgroundColor: props => props.colors.purple.colorPurple10,
        color: props => props.colors.white.colorWhite,
        ...smallSize,

        "&:hover": {
          backgroundColor: props => props.colors.purple.colorPurple20,
        },
      },
      brandBig: {
        borderColor: props => props.colors.purple.colorPurple20,
        backgroundColor: props => props.colors.purple.colorPurple10,
        color: props => props.colors.white.colorWhite,
        ...bigSize,

        "&:hover": {
          backgroundColor: props => props.colors.purple.colorPurple20,
        },
      },
      text: {
        border: "unset",
        backgroundColor: "transparent",
        color: props => props.colors.grey.colorGrey50,
        ...smallSize,
        padding: 0,

        "&:hover": {
          color: props => props.colors.grey.colorGrey55,
        },
      },
    },
  })
);

Button.defaultProps = {
  variant: "primary",
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/Button.js